import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { riseSx } from './motion';

export function UserMessage({ text }: { text: string }) {
  return (
    <Box sx={{ alignSelf: 'flex-end', maxWidth: '82%', bgcolor: 'background.paper', border: 1, borderColor: 'divider', px: 2, py: 1.25, borderRadius: 1.5, ...riseSx }}>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-line', fontSize: '0.875rem' }}>{text}</Typography>
    </Box>
  );
}
